import { render, staticRenderFns } from "./AddressInputField.vue?vue&type=template&id=12f4d7fe&scoped=true&"
import script from "./AddressInputField.vue?vue&type=script&lang=ts&"
export * from "./AddressInputField.vue?vue&type=script&lang=ts&"
import style0 from "./AddressInputField.vue?vue&type=style&index=0&id=12f4d7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4d7fe",
  null
  
)

export default component.exports